import { FC, useState } from "react";
import { Card, IconButton, Paragraph, Stack, Subheading } from "@contentful/f36-components";
import { CloseIcon } from "@contentful/f36-icons";
import { useSDK } from "@contentful/react-apps-toolkit";
import {
    NewFeaturesDialogData,
    NewFeaturesDialogParameters,
    isFormalityEnabled,
    isGlossaryEnabled,
} from "../lib";

interface NewFeaturesCardProps {
    version: string;
}

export const NewFeaturesCard: FC<NewFeaturesCardProps> = ({ version }) => {
    const sdk = useSDK();
    const installedVersion = sdk.parameters.installation.installedVersion;
    const viewedVersion = localStorage.getItem("hasViewedAnnouncement");

    const [show, setShow] = useState<boolean>(
        isFormalityEnabled &&
            isGlossaryEnabled &&
            (!installedVersion || installedVersion < version) &&
            (!viewedVersion || viewedVersion !== version)
    );

    if (!show) {
        return null;
    }

    const versionShort = version.substring(0, 3);

    const hideCard = () => {
        setShow(false);
        localStorage.setItem("hasViewedAnnouncement", version);
    };

    const handleCardClick = () => {
        sdk.dialogs
            .openCurrentApp({
                title: `👋 What's new in Linguiny ${versionShort}`,
                minHeight: 400,
                parameters: { version } satisfies NewFeaturesDialogParameters,
            })
            .then(data => {
                if (!data) {
                    return;
                }

                const { stopShowing } = data as NewFeaturesDialogData;

                if (stopShowing) {
                    hideCard();
                }
            });
    };

    return (
        <Card onClick={handleCardClick}>
            <Stack justifyContent="space-between" marginBottom="spacingS">
                <Subheading marginBottom="none">👋 Linguiny {versionShort} is here</Subheading>
                <IconButton
                    aria-label="Don't show again"
                    icon={<CloseIcon />}
                    size="small"
                    onClick={(event: React.MouseEvent) => {
                        event.stopPropagation();
                        hideCard();
                    }}
                />
            </Stack>
            <Paragraph marginBottom="none">Click to learn more about the newest changes.</Paragraph>
        </Card>
    );
};
